<mat-card *ngIf="clientsSocisList" style="padding: 0px;width:100%">
  <mat-toolbar style="font-weight:bold;width:100%">
    <div style='float:left;clear:both;width:100%'>
     <div style='float:left;clear:none;width:15%;padding:auto'>
      <button style="float: left;margin-left: 20px;width:60px; cursor:pointer" mat-icon-button (click)="openEditor()">
         <mat-icon matTooltip="{{ 'contactesTreball.afegirToolTip' | translate }}" attr.aria-label="{{ 'contactesTreball.afegirToolTip' | translate }}" matTooltipClass="tooltip-style" color="primary" style="font-size:24px">person_add</mat-icon>
      </button>
     </div>
     <div style='float:left;clear:none;width:80%;padding:auto;font-weight:normal;font-size:0.8em' *ngIf="clientsSocisList.length">
        <div style="float:left;clear:none;width:70%;text-align: center">{{ 'facturacio.camps.empresa' | translate }}</div>
        <div style="float:left;clear:none;width:10%;text-align: center">{{ 'utesTable.colPercent' | translate }}</div>
     </div>
    </div>
  </mat-toolbar>
  <mat-progress-bar mode="indeterminate" *ngIf="showAsyncProgress" style="position: absolute"></mat-progress-bar>
  <mat-card-content> 
    <mat-list style="float:left;clear:both;width:100%">
      <mat-list-item *ngIf="!clientsSocisList.length">
        {{ 'clientsSocisProjecte.senseAssignats' | translate:{ tipus: ('clientsSocisProjecte.tipusSocisLower' | translate) } }}
      </mat-list-item>
      <mat-list-item *ngFor="let item of clientsSocisList; trackBy: trackItem ;let i = index;" style="float:left;clear:both;display:inline;width:100%">
        <div style='float:left;clear:both;width:100%;border-bottom: 1px solid #EEEEEE;font-size: 1.0em'>
          <div style='float:left;clear:none;width:15%;padding:auto'>&nbsp;</div>
          <div style='float:left;clear:none;width:80%;padding:auto;margin:auto'>
             <div style="float:left;clear:none;width:70%;text-align: center">&nbsp;{{item.nom}}</div>
             <div style="float:left;clear:none;width:10%;text-align: center">&nbsp;{{item.perc_participacio}}</div>
          </div>
          <button style="margin-right: 0" matTooltip="{{ 'manageUtesSocis.esborrarToolTip' | translate }}" attr.aria-label="{{ 'manageUtesSocis.esborrarToolTip' | translate }}" matTooltipClass="tooltip-style" mat-icon-button (click)="deleteSociUte(item.id)">
            <mat-icon color="primary" style="font-size:24px">delete</mat-icon>
          </button>
        </div>
      </mat-list-item>
      <mat-list-item *ngIf="showEditor" style="float:left;clear:left;height: 100px;width: 95%;padding-top:20px;margin:auto">
        <mat-form-field style="width: 20%;padding-right: 5px">
          <input matInput name="txFiltre" [(ngModel)]="txFiltre" ngDefaultControl placeholder="{{ 'clientsSocisProjecte.filtrarPlaceholder' | translate }}" (ngModelChange)="filterClientSocis()"/>
        </mat-form-field>
       <mat-select placeholder="{{ 'clientsSocisProjecte.titolSocis' | translate }}" name="newClientSociId" style="width:30%;margin-left:10px;height:25px" [(ngModel)]="newClientSociId">
            <mat-option *ngFor="let item of availableClientsSocis" value="{{item.id}}">{{item.nom}}</mat-option>
        </mat-select>
        <mat-form-field style="width: 120px;margin-left:10px;padding-right: 5px">
          <input matInput name="newCPercPart" [(ngModel)]="newCPercPart" ngDefaultControl  placeholder="{{ 'clientsSocisProjecte.percentatgeParticipacioPlaceholder' | translate }}"/>
        </mat-form-field>
        <button style="margin-left: auto; margin-right: 0" mat-icon-button (click)="updateSociUte()" matTooltip="{{ 'contactesTreball.afegirToolTip' | translate }}" attr.aria-label="{{ 'contactesTreball.afegirToolTip' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">add</mat-icon>
        </button>
      </mat-list-item>
    </mat-list>
  </mat-card-content>
</mat-card>
<datalist id="availableClientsSocis">
  <option *ngFor="let item of availableClientsSocis" value="{{item.id}}">{{item.nom}}</option>
</datalist>
<mat-card *ngIf="error" class="error" style="float:left;clear:both">
  <mat-card-title align="center">{{ 'manageUtesSocis.errorTitol' | translate:{ status: error.status } }}</mat-card-title>
  <mat-card-subtitle align="center">{{error.statusText}}</mat-card-subtitle>
  <mat-card-content align="center">
    <p>{{error.msg}}</p>
  </mat-card-content>
</mat-card>
